import { isServer } from "@/shared/utils/isServer";

export const assertIsClient = (message: string) => {
    if (isServer) throw new Error(message);
};
